import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/shared-services/services/alert.service';

@Component({
    selector: 'app-service-offline',
    templateUrl: './service-offline.component.html'
})
export class ServiceOfflineComponent implements OnInit {

    constructor(private alertService: AlertService) { }

    ngOnInit() {
    }

}
